import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articleData';

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState(categories[0].id);

  const activeData = categories.find((c) => c.id === activeCategory) || categories[0];

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://echo64.cn/' },
          { '@type': 'ListItem', position: 2, name: '分类浏览', item: 'https://echo64.cn/categories' },
        ],
      },
      {
        '@type': 'WebPage',
        name: '喑网91分类浏览 - 文章分类与内容导航',
        description: '按分类浏览喑网91的所有内容，包括平台介绍、功能指南、版本更新、安全保障与用户故事。',
        url: 'https://echo64.cn/categories',
      },
    ],
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [activeCategory]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="min-h-screen bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-28 pb-16">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-8" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors no-underline">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">分类浏览</span>
          </nav>

          <div className="mb-10">
            <h1
              className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              分类浏览
            </h1>
            <p className="text-sm md:text-base text-foreground-600">
              按主题分类浏览喑网91的全部内容，快速找到您感兴趣的板块
            </p>
          </div>

          {/* Category Tabs */}
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  activeCategory === cat.id
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                {cat.name}
              </button>
            ))}
          </div>

          {/* Category Info */}
          <div className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 mb-8">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className={`${activeData.icon} text-primary-600 text-sm`}></i>
              </div>
              <h2 className="text-lg font-semibold text-foreground-900">
                {activeData.name}
              </h2>
            </div>
            <p className="text-sm text-foreground-600">{activeData.description}</p>
          </div>

          {/* Articles */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {activeData.articles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 no-underline"
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">
                    {activeData.name}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}